import { create } from 'zustand';
import { SystemAlertData } from '../../../shared/dto/EntityRepository';


interface AdminSystemAlertViewState {
  activeSystemAlert: SystemAlertData | null;
  setActiveSystemAlert: (systemAlert: SystemAlertData | null) => void;
  clearActiveSystemAlert: () => void;
}

export const useAdminSystemAlertViewStore = create<AdminSystemAlertViewState>((set) => ({
  activeSystemAlert: null,
  setActiveSystemAlert: (activeSystemAlert) => set({ activeSystemAlert }),
  clearActiveSystemAlert: () => set({ activeSystemAlert: null }),
}));


interface AdminSystemAlertListState {
  systemAlertList: SystemAlertData[];
  setSystemAlertList: (systemAlertList: SystemAlertData[]) => void;
}

export const useAdminSystemAlertListStore = create<AdminSystemAlertListState>((set) => ({
  systemAlertList: [],
  setSystemAlertList: (systemAlertList) => set({ systemAlertList }),
}));